import { fmt, useI18n } from '@/i18n';
import type { ArtworkWarning } from './processArtwork';

/** Localised texts for artwork warnings. */
export function useArtworkWarningTexts() {
  const { d } = useI18n();
  const w = d.cfg.warnings;
  return (list: ArtworkWarning[]): string[] =>
    list.map((x) => {
      switch (x.code) {
        case 'svgSanitized':
          return fmt(w.svgSanitized, { n: x.n });
        case 'pdfPages':
          return fmt(w.pdfPages, { n: x.n });
        default:
          return w[x.code];
      }
    });
}
